import { useTranslations as t } from "@/core/hooks/useTranslations/useTranslations";
import { Box } from "@mui/system";
import { Typography } from "@mui/material";
import { HeadingLevel } from "@/core/types/types";
import Icon from "@/core/components/Icon/Icon";

const FlightProblemAccordion = () => {
  const FLIGHT_PROBLEM_ICONS: string[] = [
    "delayed",
    "cancelled",
    "rerouted",
    "returned",
    "denied_boarding",
    "missed_connection",
  ];

  return (
    <>
      {FLIGHT_PROBLEM_ICONS.map((item: string, index: number) => {
        return (
          <Box mt={index === 0 ? -1 : 3} key={item}>
            <Box display="flex" alignItems="center" justifyContent="row">
              <Box mr={1} mt={0.5}>
                <Icon
                  src={`images/icons/flight-problems/${item}.svg`}
                  alt="flight-problem-icon"
                />
              </Box>
              <Typography variant={HeadingLevel.H3} sx={{ fontWeight: 700 }}>
                {t(`flightProblem.${item}`)}
              </Typography>
            </Box>
            <Box ml={5}>
              <Typography variant={HeadingLevel.Body2}>
                {t(`flightProblem.${item}.description`)}
              </Typography>
            </Box>
          </Box>
        );
      })}
    </>
  );
};

export default FlightProblemAccordion;
